import { PublicHostedAuthSession } from '@unipile/provider-shared';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { axiosInstance } from '../libs/axios';

async function getHostedAuthSession(): Promise<PublicHostedAuthSession> {
  const result = await axiosInstance.get<PublicHostedAuthSession>('/admin/hosted-auth/load-session');

  return result.data;
}

export function useHostedAuthSession() {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();

  const token = searchParams.get('token');

  return useQuery({
    queryKey: ['session'],
    queryFn: async () => {
      if (!token) throw new Error(t('Error.tokenRequired'));

      axiosInstance.defaults.headers.common['x-hosted-auth-session'] = token;

      return getHostedAuthSession();
    },
    retry: false,
    staleTime: Infinity,
  });
}
